<script>
    import { appSession, appConstants } from "../stores/app.js";
  
    // resolve stripe config
    export function GetRate(postcode) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", $appConstants.apiURLBase + "taxjar/rate/" + postcode);
        xhr.setRequestHeader("Authorization", "Bearer " + $appSession.authorisationToken);
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.send("");
        xhr.onload = () => {
          try {
            if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
            let response = JSON.parse(xhr.response);
            if (response.success != true) throw response.errormessage;
            resolve(response.data.taxrate);
          } catch (e) {
            reject(e);
          }
        };
        xhr.onerror = () => {
          reject("NetworkError");
        };
      });
    }
  
    // get tax rate and amount for a given state, postcode, amount
    export function PostRate(fields) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", $appConstants.apiURLBase + "taxjar/rate");
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        xhr.setRequestHeader(
          "Authorization",
          "Bearer " + $appSession.authorisationToken
        );
        xhr.send(JSON.stringify(fields));
        xhr.onload = () => {
          try {
            if (xhr.status < 200 || xhr.status >= 300) throw "NetworkError";
            let response = JSON.parse(xhr.response);
            if (response.success != true) throw response.errormessage;
            resolve(response);
          } catch (error) {
            reject(error);
          }
        };
        xhr.onerror = () => {
          reject("NetworkError");
        };
      });
    }
  
  </script>
  